export const getMicrosoftTeamsURL = (email: string) => {
  return `https://teams.microsoft.com/l/chat/0/0?users=${email}`;
};
